module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('label', {
    staticClass: "myLabel c-hand"
  }, [_c('input', {
    staticClass: "form-input",
    attrs: {
      "type": "file",
      "disabled": _vm.saving
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _c('span', {
    class: {
      loading: _vm.saving
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload")])]), _vm._v(" "), (_vm.error) ? _c('label', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d46f22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/upload.vue
// module id = 472
// module chunks = 1